import { Typography } from 'components/Contentful'
import { AchieveLink } from 'components/AchieveLink'
import { Home } from 'react-feather'
import { Box } from '@achieve/ascend'
import { Breadcrumbs } from '@mui/material'

function AuthorBreadCrumbs({ authorName }) {
  return (
    <Box
      paddingTop={3}
      display={'flex'}
      alignItems={'center'}
      gap={1}
      className={
        '[&_a]:text-xs [&_a]:text-inherit [&_p]:text-xs hover:[&_li]:text-blue-500 last:[&_li]:text-blue-500 [&_.content-icon]:flex [&_.content-icon]:items-center [&_.text]:text-blue-500 [&_.text]:leading-[0]'
      }
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        className={
          '[&_a]:text-xs [&_a]:text-inherit [&_p]:text-xs hover:[&_li]:text-blue-500 last:[&_li]:text-blue-500 [&_.content-icon]:flex [&_.content-icon]:items-center [&_.text]:text-blue-500 [&_.text]:leading-[0]'
        }
      >
        <AchieveLink
          underline="hover"
          color="inherit"
          href="/"
          track={{
            list_name: 'Breadcrumb',
            click_text: `Home Page`,
            click_id: `Home Page`,
            click_position: '0',
            nav_link_section: 'Breadcrumb',
            track_event: 'page_nav_click',
            event_action: 'link_click',
            event_type: 'link_click',
          }}
          data-testid="home-breadcrumb"
        >
          <Home size={14} />
        </AchieveLink>
        <AchieveLink
          track={{
            list_name: 'Author Breadcrumb',
          }}
          href={'/authors'}
          data-testid="author-listing-breadcrumb"
        >
          <Typography content={'Authors'} />
        </AchieveLink>
        {authorName && <Typography content={authorName} data-testid="author-page-breadcrumb" />}
      </Breadcrumbs>
    </Box>
  )
}

export { AuthorBreadCrumbs }
